<!-- @Author Shyam @Date 26/03/2026 @Description: Workflow Steps Component -->

<div
  class="topdiv mt-3 mt-md-4 me-md-4 p-2"
  style="overflow-x: hidden; overflow-y: auto; max-height: 90vh"
>
  <div class="row topRowMargins headerStyle px-3 align-items-center">
    <div class="col d-flex align-items-center">
      <span class="breadcrumb-link" (click)="goToWorkflows()"> Workflows </span>

      <span> > </span>

      <span class="breadcrumb-link" (click)="goToWorkflowPopup()">
        {{ workflowName }}
      </span>
    </div>

    <!-- Right side buttons -->
    <div
      class="col-auto d-flex flex-wrap justify-content-end mt-2 mt-md-0"
      style="gap: 10px"
    >
      <div class="me-2 mb-2">
        <app-common-button
          [label]="buttonName"
          [title]="buttonName"
          [critical]="true"
          [buttonId]="1111"
          width="110px"
          (clicked)="onSubmit()"
        >
        </app-common-button>
      </div>

      <div class="mb-2">
        <app-common-button
          label="Cancel"
          title="Cancel"
          [critical]="true"
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          (clicked)="onCancel()"
        >
        </app-common-button>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="mt-4 ps-3 ps-md-0 mb-3">
    <form novalidate [formGroup]="validations_form">
      <div class="row g-3 px-2 px-md-4">
        <!-- Lifecycle -->
        <div class="col-12 col-sm-6 col-lg-4 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Step Name</mat-label>
            <input
              matInput
              placeholder="Workflow Name"
              type="text"
              formControlName="stepname"
              [(ngModel)]="workflowDto.stepname"
              required
            />
            <mat-error *ngFor="let validation of validation_messages.stepname">
              <span
                *ngIf="
                  validations_form.get('stepname').hasError(validation.type) &&
                  (validations_form.get('stepname').dirty ||
                    validations_form.get('stepname').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg-4 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Step Type</mat-label>
            <mat-select
              formControlName="steptype"
              [(ngModel)]="workflowDto.steptype"
              (selectionChange)="onStepTypeChange($event)"
            >
              <mat-option
                *ngFor="let type of stepTypes"
                [value]="type.lookupcode"
              >
                {{ type.lookupvalue }}
              </mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.steptype">
              <span
                *ngIf="
                  validations_form.get('steptype').hasError(validation.type) &&
                  (validations_form.get('steptype').dirty ||
                    validations_form.get('steptype').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Description -->
        <div class="col-12 col-sm-6 col-lg-4 mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Description</mat-label>
            <input
              matInput
              type="text"
              placeholder="Description"
              formControlName="description"
              [(ngModel)]="workflowDto.description"
            />
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 mb-3">
          <ng-container
            *ngIf="selectedStepType != 'DECISION'; else endNextStep"
          >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label i18n="@@Targetstdcode">Next Step</mat-label>
              <mat-select
                formControlName="nextsteps"
                (selectionChange)="onNextStepChange($event)"
                [disabled]="selectedStepType === 'END'"
              >
                <!-- <mat-option value="END">END</mat-option> -->
                <mat-option value="PLACEHOLDER">+ Create New Step</mat-option>
                <mat-option
                  *ngFor="let nextstep of nextstepsData"
                  [value]="nextstep.stepid"
                >
                  {{ nextstep.stepname }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngFor="let validation of validation_messages.nextsteps"
              >
                <span
                  *ngIf="
                    validations_form
                      .get('nextsteps')
                      .hasError(validation.type) &&
                    (validations_form.get('nextsteps').dirty ||
                      validations_form.get('nextsteps').touched)
                  "
                >
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <ng-template #endNextStep>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Next step</mat-label>
            <input matInput value="Determined by rules" disabled />
          </mat-form-field>
        </ng-template>
        <div
          *ngIf="selectedStepType === 'TASK'"
          class="col-12 col-sm-6 col-lg-4 mb-3"
        >
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Task Mode</mat-label>
            <mat-select
              formControlName="taskmode"
              [(ngModel)]="workflowDto.taskmode"
            >
              <mat-option *ngFor="let t of taskModes" [value]="t">
                {{ t }}
              </mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.taskmode">
              <span
                *ngIf="
                  validations_form.get('taskmode').hasError(validation.type) &&
                  (validations_form.get('taskmode').dirty ||
                    validations_form.get('taskmode').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div
          class="col-12 col-sm-6 col-lg-4"
          *ngIf="selectedStepType === 'STATECHANGE'"
        >
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Next State</mat-label>
            <mat-select
              formControlName="nextstate"
              (selectionChange)="onStartStateChange($event)"
              [(ngModel)]="workflowDto.nextstate"
            >
              <mat-option *ngFor="let state of states" [value]="state.stateid">
                {{ state.statename }}
              </mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.nextstate">
              <span
                *ngIf="
                  validations_form.get('nextstate').hasError(validation.type) &&
                  (validations_form.get('nextstate').dirty ||
                    validations_form.get('nextstate').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
    <mat-divider></mat-divider>
    <div
      *ngIf="selectedStepType === 'START' && validations_form"
      class="px-2 px-md-4 mt-3"
    >
      <form [formGroup]="validations_form">
        <!-- Add Control Button -->
        <div *ngIf="startOptions.length === 0" class="mb-3">
          <label
            (click)="addStartControl()"
            style="
              margin-top: 6px;
              background: green;
              margin-bottom: auto;
              padding: 2px 5px 0px 5px;
              border-radius: 15px;
            "
            ><em
              class="fas fa-plus"
              style="color: antiquewhite; font-size: large"
              title="+ Add Control"
            ></em
          ></label>
        </div>

        <!-- Controls -->
        <div formArrayName="startOptions" *ngIf="startOptions.length > 0">
          <div
            *ngFor="let control of startOptions.controls; let i = index"
            [formGroupName]="i"
            class="border rounded p-3 mb-3 bg-light"
          >
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="mb-0">Control {{ i + 1 }}</h5>
              <label
                (click)="removeStartControl(i)"
                style="
                  margin-top: 6px;

                  margin-bottom: auto;
                  padding: 2px 5px 0px 5px;
                  border-radius: 15px;
                "
                ><em
                  class="fas fa-times"
                  style="font-size: large"
                  title="Close"
                ></em
              ></label>
            </div>

            <div class="row g-3">
              <!-- Participant Label -->
              <div class="col-12 col-sm-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Participant Label</mat-label>
                  <input matInput formControlName="participantLabel" />
                </mat-form-field>
              </div>

              <!-- PARTICIPANT TYPE RADIO -->
              <div class="col-12">
                <label class="fw-bold mb-2">Add Participants</label>

                <mat-radio-group formControlName="participantType">
                  <div class="mb-2">
                    <mat-radio-button value="TASK_OWNER">
                      Allow workflow task owners to select participants
                    </mat-radio-button>
                  </div>

                  <div class="mb-2">
                    <mat-radio-button value="ROLE">
                      Use roles as participants
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
              </div>

              <!-- ROLES ALLOWED -->
              <div
                class="col-12 col-sm-6"
                *ngIf="control.get('participantType')?.value === 'ROLE'"
              >
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Roles allowed to participate</mat-label>

                  <mat-select formControlName="rolesAllowed" multiple>
                    <mat-option
                      *ngFor="let option of Accesstypes"
                      [value]="option[1]"
                    >
                      {{ option[1] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- ROLES NOT ALLOWED -->
              <div
                class="col-12 col-sm-6"
                *ngIf="control.get('participantType')?.value === 'ROLE'"
              >
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Roles not allowed</mat-label>

                  <mat-select formControlName="rolesNotAllowed" multiple>
                    <mat-option
                      *ngFor="let option of Accesstypes"
                      [value]="option[1]"
                    >
                      {{ option[1] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- ADD ANOTHER CONTROL -->

          <label
            (click)="addStartControl()"
            style="
              margin-top: 6px;
              background: green;
              margin-bottom: auto;
              padding: 2px 5px 0px 5px;
              border-radius: 15px;
            "
            ><em
              class="fas fa-plus"
              style="color: antiquewhite; font-size: large"
              title="+ Add Another Control"
            ></em
          ></label>
        </div>
      </form>
    </div>
    <app-task-workflow-step
      *ngIf="selectedStepType === 'TASK' && validations_form"
      class="px-2 px-md-4 mt-3"
      [taskData]="data?.taskStep"
      [participants]="allParticipants"
      [workflowId]="this.workflowId"
      (taskFormChange)="onTaskFormChange($event)"
    ></app-task-workflow-step>

    <app-decision-workflow-step
      *ngIf="selectedStepType === 'DECISION' && validations_form"
      [decisionFormChange]="data?.taskStep"
      [tasks]="nextstepsData"
      [taskAction]="taskSteps"
      [verdicts]="allVerdicts"
      [workflowId]="this.workflowId"
    ></app-decision-workflow-step>

    <!-- <div class="row mt-4 justify-content-end g-2 px-3">
     
      <app-common-button
        [label]="buttonName"
        [title]="buttonName"
        [critical]="true"
        [buttonId]="1111"
        width="110px"
        (clicked)="onSubmit()"
        style="margin-left: 6px; margin-right: 6px"
      >
      </app-common-button>
      <app-common-button
        label="Cancel"
        title="Cancel"
        [critical]="true"
        [buttonId]="1111"
        variant="cancel"
        width="110px"
        (clicked)="onCancel()"
        style="margin-left: 6px; margin-right: 6px"
      >
      </app-common-button>
      
    </div> -->
  </div>
</div>
